
export enum Language {
  cs= 'cs',
  de= 'de',
  en= 'en',
  es= 'es',
  it= 'it',
  pl= 'pl',
  fr= 'fr',
  pt= 'pt',
  nl= 'nl',
  ro= 'ro',
  ru= 'ru',

}